<template>
  <o-form-group :label="label">
    <o-textarea-control v-model="localValue" :readonly="readonly"></o-textarea-control>
  </o-form-group>
</template>

<script>
  export default {
    name: 'o-textarea',

    props: {
      value: {
        default: null
      },
      label: {
        type: String
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      localValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {}
  }
</script>
